import { render } from "./RecentlyUpdatedWellsList.vue?vue&type=template&id=7538665c&ts=true"
import script from "./RecentlyUpdatedWellsList.vue?vue&type=script&lang=ts"
export * from "./RecentlyUpdatedWellsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../build_modules/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__